__webpack_require__.p = "https://bundle.stayforlong.com/20260119.1/_next/";